import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";

import ProfileImage from "../../assets/images/Profile.png";
import CalenderImage from "../../assets/images/Calendar.png";
import LocationImage from "../../assets/images/Location2.png";
import TimeImage from "../../assets/images/Time2.png";
import TicketImage from "../../assets/images/Ticket.png";
import SuportImage from "../../assets/images/Suport.png";
import noItemImg from "../../assets/images/noItem.svg";
import "./ProfileReservedHistory.scss";
import HistoryListItem from "../HistoryListItem/HistoryListItem";
import NothingToShowBox from "../NothingToShowBox/NothingToShowBox";

const ProfileReservedHistory = (props) => {
  const [activeTab, setActiveTab] = useState({
    doneReserves: true,
    doingReserves: false,
  });
  const [doneReserves, setDoneReserves] = useState([]);
  const [doingReserves, setDoingReserves] = useState([]);
  useEffect(() => {
    setDoneReserves(props.data.filter((item) => item.isFinaly));
    setDoingReserves(props.data.filter((item) => !item.isFinaly));
  }, [props.data]);
  const changeTabHandler = (target, category) => {
    let btn = document.querySelectorAll(".historyTabBtn");
    btn.forEach((item) => {
      item.classList.remove("active");
    });
    target.classList.add("active");
    if (category === "done") {
      setActiveTab({
        doneReserves: true,
        doingReserves: false,
      });
    } else if (category === "doing") {
      setActiveTab({
        doneReserves: false,
        doingReserves: true,
      });
    }
  };
  return (
    <div className="profileReservedHistory">
      <p className="reservedHistoryHeader">تاریخچه سفارش ها</p>
      <div className="reservedHstoryTab">
        <button className="historyTabBtn active" onClick={(e) => changeTabHandler(e.target, "done")}>
          سفارش های انجام شده
        </button>
        <button className="historyTabBtn" onClick={(e) => changeTabHandler(e.target, "doing")}>
          سفارش های در حال انجام
        </button>
      </div>
      {activeTab.doneReserves && (
        <>
          {doneReserves.length > 0 ? (
            <div className="historyList">
              {doneReserves?.map((item, index) => {
                return (
                  <div className="prItem" key={index}>
                    {item.orderDetails.map((i) => {
                      return <HistoryListItem deliveryCode={item.deliveryCode} key={index} data={i} done={true} />;
                    })}
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="noItemWrapper">
              <img className="noItem" src={noItemImg} />
              <p className="noText">هیچ موردی یافت نشد</p>
            </div>
          )}
        </>
      )}
      {activeTab.doingReserves && (
        <>
          {doingReserves.length > 0 ? (
            <div className="historyList">
              {doingReserves?.map((item, index) => {
                return (
                  <div className="prItem" key={index}>
                    {item.orderDetails.map((i) => {
                      return <HistoryListItem deliveryCode={item.deliveryCode} key={index} data={i} />;
                    })}
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="noItemWrapper">
              <img className="noItem" src={noItemImg} />
              <p className="noText">هیچ موردی یافت نشد</p>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default React.memo(withRouter(ProfileReservedHistory));
